<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Huurtoeslag als bijdrage voor betalen huurwoning
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Huurtoeslag is een bijdrage om de huur van je woning mee te kunnen betalen. Om de toeslag te kunnen
                krijgen, mag je niet te veel verdienen. Ook mag de huur niet te hoog zijn. Wel gelden er enkele
                voorwaarden.
                <div class="space10"></div>

                <b>Je inkomen mag niet te hoog zijn</b><br/>
                Hoe hoog je inkomen mag zijn, hangt af van je huur, je leeftijd en de samenstelling van je huishouden.
                <div class="space10"></div>

                <b>Je huur mag niet te hoog zijn</b><br/>
                De maximale huur verandert elk jaar. Veelal mag de huur niet hoger zijn dan € 900,07. <br/>
                Zijn alle bewoners jonger dan 23 jaar? Dan mag de huur niet hoger zijn dan € 477,20, behalve als je al
                een kind hebt dat bij ke woont. Dan mag de huur toch € 900,07 zijn.
                <div class="space10"></div>

                <b>Je huurt een zelfstandige woonruimte</b><br/>
                Een zelfstandige woonruimte heeft in ieder geval een eigen toegangsdeur die op slot kan, keuken en wc.
                En vanaf 1 maart 2024 moet de woning ook een eigen douche of badkamer hebben.<br/>
                Maar niet voor álle zelfstandige woningen kun je huurtoeslag krijgen. Voor een woonboot kunt u
                bijvoorbeeld geen huurtoeslag krijgen. Ook al is dit een zelfstandige woonruimte. Voor een
                recreatiewoning kun je meestal ook geen huurtoeslag krijgen. En voor sommige onzelfstandige woningen
                kun je juist wél weer huurtoeslag krijgen. Kijk <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/huurtoeslag/content/voor-welke-woningen-huurtoeslag"
                    target="_blank">hier</a> voor welke woningen
                je huurtoeslag kunt krijgen.
                <div class="space10"></div>

                <b>Je vermogen mag niet te hoog zijn</b><br/>
                Je mag ook niet te veel vermogen hebben, zoals spaargeld. Iedere bewoner mocht op 1 januari 2025
                maximaal € 37.395 hebben. Partners mochten samen op 1 januari 2025 maximaal € 74.790 hebben.<br/>
                Heb je een thuiswonende kind met vermogen dat jonger is dan 18 jaar? Dat bedrag telt dan mee bij je
                vermogen.
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Zoveel huurders, zoveel situaties
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Ben je nog geen 18? Heb je AOW? Ben je geen Nederlander? Woont er iemand met een handicap in huis?
                Twijfel je of je servicekosten moet meerekenen? Of zit je in een bijzondere situatie?
                <div class="space10"></div>
                Lees meer over deze situaties en de <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/huurtoeslag/voorwaarden/voorwaarden"
                    target="_blank">voorwaarden</a> die gelden voor het huurtoeslag.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Kale huurprijs en kale kosten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Huurprijs</b><br/>
                Met de term kale huurprijs wordt de huurprijs bedoeld die je betaalt voor de woning zonder bijkomende
                kosten zoals gas, water, elektriciteit, servicekosten of andere toeslagen. Het is dus alleen de huur
                voor het gebruik van de woning zelf, exclusief alle extra kosten.
                <div class="space10"></div>

                Bij de huurtoeslag wordt meestal de kale huurprijs in aanmerking genomen om te bepalen of je in
                aanmerking komt voor toeslag en hoeveel je kunt krijgen. De bijkomende kosten die je voor gas, water,
                licht, en andere services betaalt, tellen hier niet mee.
                <div class="space10"></div>

                <b>Energiekosten</b><br/>
                Bij de huurtoeslag wordt met de energiekosten per maand bedoeld de kosten die je maandelijks betaalt
                voor gas, elektriciteit, en soms ook voor water. Deze kosten zijn essentieel voor het bepalen van de
                hoogte van je huurtoeslag, omdat de toeslag ook rekening houdt met de energiebehoefte van je woning en
                jouw situatie.
                <div class="space10"></div>

                De energiekosten die in aanmerking komen voor huurtoeslag zijn dus de kosten die je daadwerkelijk
                betaalt voor de levering van energie (gas, elektriciteit) en soms ook het water, en worden vaak
                afzonderlijk van de huurprijs vermeld op je huurovereenkomst of je maandelijkse energierekeningen.
                <div class="space10"></div>

                Het is belangrijk om te weten dat de energiekosten niet hetzelfde zijn als de kale huurprijs, die alleen
                betrekking heeft op de huur van de woning zelf zonder bijkomende kosten. De energiekosten kunnen invloed
                hebben op het totaalbedrag van de huurtoeslag waarvoor je in aanmerking komt, maar worden apart berekend
                van de huurprijs.
                <div class="space10"></div>

                <b>Huismeesterkosten</b><br/>
                Huismeesterkosten zijn kosten die je betaalt voor de diensten van een huismeester in een woningcomplex
                of appartementencomplex. De huismeester is vaak verantwoordelijk voor het onderhouden van de
                gemeenschappelijke ruimtes, het toezicht houden op het gebouw, en soms voor kleine reparaties of het
                regelen van andere praktische zaken in het complex.
                <div class="space10"></div>
                Bij de huurtoeslag worden huismeesterkosten beschouwd als servicekosten. Deze servicekosten zijn kosten
                die je betaalt bovenop de kale huurprijs voor aanvullende diensten die verband houden met het gebruik
                van de woning of het gebouw. Servicekosten kunnen bijvoorbeeld ook kosten zijn voor het schoonmaken van
                gemeenschappelijke ruimtes, het onderhouden van de lift, of het beheren van de parkeerplaats.
                <div class="space10"></div>
                Het is belangrijk te weten dat servicekosten (zoals huismeesterkosten) niet meetellen bij het bepalen
                van de kale huurprijs, die de basis is voor de huurtoeslag. Alleen de kale huurprijs (de huur voor de
                woning zelf) telt mee voor de berekening van de huurtoeslag, en servicekosten zoals huismeesterkosten
                kunnen daar niet voor worden meegeteld.
                <div class="space10"></div>

                <b>Servicekosten</b><br/>
                Servicekosten zijn de kosten die een huurder betaalt voor extra diensten en voorzieningen die worden
                geleverd bovenop de kale huurprijs. Deze kosten zijn voor zaken die niet direct betrekking hebben op het
                huren van de woning zelf, maar wel op het gebruik van de gemeenschappelijke ruimtes of bepaalde
                faciliteiten van het gebouw waarin je woont.<br/>
                Servicekosten kunnen dus betrekking hebben op bijvoorbeeld:<br/>
                <li class="list">Onderhoud en schoonmaak van gemeenschappelijke ruimtes (zoals gangen, trappenhuizen, en
                    de tuin).
                </li>
                <li class="list">Beveiliging of toezicht, zoals de kosten voor een huismeester of de beveiliging van het
                    gebouw.
                </li>
                <li class="list"> Energieverbruik voor de gemeenschappelijke ruimtes (bijvoorbeeld verlichting in de
                    gangen of het
                    verwarmen van de hal).
                </li>
                <li class="list">Verwarming en warm water voor het gebouw als dit centraal geregeld wordt en niet
                    individueel per woning.
                </li>
                <li class="list">Afvalverwerking en het onderhoud van de afvalcontainers of -systemen.</li>
                <li class="list">Liftonderhoud als het gebouw een lift heeft.</li>

                Belangrijk om te weten. Servicekosten komen bovenop de kale huurprijs en zijn vaak apart vermeld op je
                huurcontract of maandelijkse afrekening. Ze zijn dus geen kosten voor de woning zelf, maar voor extra
                diensten die je als huurder gebruikt of nodig hebt in het gebouw of de omgeving van je woning.
                <div class="space10"></div>

                <b>Schoonmaakkosten</b><br/>
                Met schoonmaakkosten in de context van de huurtoeslag wordt bedoeld de kosten die een huurder betaalt
                voor het schoonmaken van de gemeenschappelijke ruimtes in een appartementencomplex of woningcomplex. Dit
                betreft dus niet het schoonmaken van de woning zelf, maar van gedeelde delen van het gebouw, zoals:<br/>
                <li class="list">Trappenhuizen</li>
                <li class="list">Gangen</li>
                <li class="list">Lift</li>
                <li class="list">De gemeenschappelijke tuin of andere buitenruimtes</li>
                <li class="list">De entree of hal van het gebouw</li>
                <div class="space10"></div>
                Deze schoonmaakkosten zijn dus aanvullende kosten, wat betekent dat ze niet deel uitmaken van de kale huurprijs.
                <div class="space10"></div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Tot wanneer huurtoeslag aanvragen
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De zorgtoeslag, huurtoeslag en kindgebonden budget kun je nog aanvragen tot en met 1 september in het
                volgende jaar. Je kunt bijvoorbeeld nog zorgtoeslag over 2024 aanvragen tot en met 1 september 2025.
                <div class="space10"></div>
                Heb je nog vóór 2 september van het nieuwe jaar toeslag over het voorgaande jaar aangevraagd? Dan kan
                het een tijdje duren voordat je de toeslag krijgt. Je moet eerst wachten op de definitieve berekening
                van het voorgaande jaar. Binnen 1 week nadat je deze hebt gekregen, maakt de Belastingdienst het bedrag
                in 1 keer aan je over.
                <div class="space10"></div>

                <b>Stopgezette toeslag</b><br/>
                Had je al een toeslag die je hebt stopgezet? En wil je deze opnieuw aanvragen? Dan heb je langer de
                tijd. Je kunt die toeslag nog aanvragen ná 1 september van het volgende jaar. Aanvragen kan dan niet
                meer via online, ook niet via Mijn toeslagen. Schrijf de Belastingdienst een <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/hoe_werken_toeslagen/niet_met_ons_eens_toeslagen/verzoek-om-een-beslissing-over-een-toeslag-te-herzien"
                    target="_blank">brief</a> en vraag de Belastingdienst om de ‘stopzetting te herzien’.
                <div class="space10"></div>

                <b>Uitstel voor de aangifte inkomstenbelasting</b><br/>
                Dan heb je meer tijd om toeslag aan te vragen. Want je kunt dan nog zorgtoeslag, huurtoeslag en
                kindgebonden budget aanvragen tot de datum waarop het uitstel afloopt. Dat kan uitstel zijn voor de
                aangifte óf voor de aangifte van je toeslagpartner. Huurtoeslag kun je ook aanvragen zolang een
                medebewoner nog uitstel heeft.
                <div class="space10"></div>

            </div>
        </div>
    </div>

</div>
